import {
  SET_HAS_NEW_NOTIFICATION,
  SET_ARE_NOTIFICATIONS_PAUSED,
  SET_UNREAD_NOTIFICATIONS_COUNT,
} from "../Actions/types";

const INITIAL_STATE = {
  hasUnreadNotification: false,
  areNotificationsPaused: false,
  unreadNotificationsCount: null,
};

const notificationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_HAS_NEW_NOTIFICATION:
      return { ...state, hasUnreadNotification: action.payload };

    case SET_ARE_NOTIFICATIONS_PAUSED:
      return { ...state, areNotificationsPaused: action.payload };

    case SET_UNREAD_NOTIFICATIONS_COUNT:
      return { ...state, unreadNotificationsCount: action.payload };

    default:
      return state;
  }
};

export default notificationsReducer;
